import { render, staticRenderFns } from "./IP_ByMdcPrintable.vue?vue&type=template&id=2f98576a&scoped=true&"
import script from "./IP_ByMdcPrintable.vue?vue&type=script&lang=js&"
export * from "./IP_ByMdcPrintable.vue?vue&type=script&lang=js&"
import style0 from "./IP_ByMdcPrintable.vue?vue&type=style&index=0&id=2f98576a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f98576a",
  null
  
)

export default component.exports